import type { AppResourceBinding } from "@rally/agreed";
import { AppSourceControls } from "./app-source-controls.tsx";

export type EditableApp = {
  id: string;
  visibility: string;
  setupAvailable?: boolean;
  placements: Array<{
    id: string;
    context: string;
    contextId: string | null;
    contextName: string | null;
    openMode: string;
    channel: string | null;
    display: Record<string, unknown>;
  }>;
  bindings: AppResourceBinding[];
  grants: Array<{ id: string; scope: string; scopeId: string | null }>;
  repositories: Array<{
    name: string;
    url: string;
    deployHost: string | null;
    token: { held: boolean; hint: string | null; addedAt: string | null };
  }>;
  shipping: Array<{
    project: string;
    projectName: string;
    repo: string;
    sourceUrl: string;
    branch: string;
    target: string;
    gate: string | null;
  }>;
};

export function AppControls({ app, reload }: { app: EditableApp; reload: () => void }) {
  return <AppSourceControls app={app} reload={reload} />;
}
